<div class="multiline-cell">
  <ul>
    @for (value of dataContext; track value; let i = $index) {
      <li>{{ value }}</li>
    }
  </ul>
</div>
